module.exports = __webpack_public_path__ + "static/media/img9.a3a8157c.jpg";